import React from 'react';
import { useNavigate } from 'react-router-dom'; // For programmatically navigating
import { isMobile } from "react-device-detect";
// Mobile floor components
import Floor1ComponentMobile from '../MobileImageMap/Floor1Component.jsx';
import Floor2ComponentMobile from '../MobileImageMap/Floor2Component.jsx';
import Floor3ComponentMobile from '../MobileImageMap/Floor3Component.jsx';
import Floor4ComponentMobile from '../MobileImageMap/Floor4Component.jsx';
import Floor5ComponentMobile from '../MobileImageMap/Floor5Component.jsx';
import Floor6ComponentMobile from '../MobileImageMap/Floor6Component.jsx';
import Floor7ComponentMobile from '../MobileImageMap/Floor7Component.jsx';
import Floor8ComponentMobile from '../MobileImageMap/Floor8Component.jsx';
import Floor9ComponentMobile from '../MobileImageMap/Floor9Component.jsx';
import Floor10ComponentMobile from '../MobileImageMap/Floor10Component.jsx';
import Floor11ComponentMobile from '../MobileImageMap/Floor11Component.jsx';
import Floor12ComponentMobile from '../MobileImageMap/Floor12Component.jsx';
import Floor13ComponentMobile from '../MobileImageMap/Floor13Component.jsx';
import Floor15ComponentMobile from '../MobileImageMap/Floor15Component.jsx';
import Floor17ComponentMobile from '../MobileImageMap/Floor17Component.jsx';
import Floor19ComponentMobile from '../MobileImageMap/Floor19Component.jsx';
import Floor22ComponentMobile from '../MobileImageMap/Floor22Component.jsx';
import Floor24ComponentMobile from '../MobileImageMap/Floor24Component.jsx';
import Floor26ComponentMobile from '../MobileImageMap/Floor26Component.jsx';
import Floor28ComponentMobile from '../MobileImageMap/Floor28Component.jsx';
import Floor30ComponentMobile from '../MobileImageMap/Floor30Component.jsx';
import Floor32ComponentMobile from '../MobileImageMap/Floor32Component.jsx';
import Floor34ComponentMobile from '../MobileImageMap/Floor34Component.jsx';
import Floor36ComponentMobile from '../MobileImageMap/Floor36Component.jsx';
import Floor38ComponentMobile from '../MobileImageMap/Floor38Component.jsx';

// Desktop floor components
import Floor1Component from '../ImageMapComponent/Floor1Component.jsx';
import Floor2Component from '../ImageMapComponent/Floor2Component.jsx';
import Floor3Component from '../ImageMapComponent/Floor3Component.jsx';
import Floor4Component from '../ImageMapComponent/Floor4Component.jsx';
import Floor5Component from '../ImageMapComponent/Floor5Component.jsx';
import Floor6Component from '../ImageMapComponent/Floor6Component.jsx';
import Floor7Component from '../ImageMapComponent/Floor7Component.jsx';
import Floor8Component from '../ImageMapComponent/Floor8Component.jsx';
import Floor9Component from '../ImageMapComponent/Floor9Component.jsx';
import Floor10Component from '../ImageMapComponent/Floor10Component.jsx';
import Floor11Component from '../ImageMapComponent/Floor11Component.jsx';
import Floor12Component from '../ImageMapComponent/Floor12Component.jsx';
import Floor13Component from '../ImageMapComponent/Floor13Component.jsx';
import Floor15Component from '../ImageMapComponent/Floor15Component.jsx';
import Floor17Component from '../ImageMapComponent/Floor17Component.jsx';
import Floor19Component from '../ImageMapComponent/Floor19Component.jsx';
import Floor22Component from '../ImageMapComponent/Floor22Component.jsx';
import Floor24Component from '../ImageMapComponent/Floor24Component.jsx';
import Floor26Component from '../ImageMapComponent/Floor26Component.jsx';
import Floor28Component from '../ImageMapComponent/Floor28Component.jsx';
import Floor30Component from '../ImageMapComponent/Floor30Component.jsx';
import Floor32Component from '../ImageMapComponent/Floor32Component.jsx';
import Floor34Component from '../ImageMapComponent/Floor34Component.jsx';
import Floor36Component from '../ImageMapComponent/Floor36Component.jsx';
import Floor38Component from '../ImageMapComponent/Floor38Component.jsx';

const floorList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 17, 19, 22, 24, 26, 28, 30, 32, 34, 36, 38];

const floorComponents = {
  1: { desktop: Floor1Component, mobile: Floor1ComponentMobile },
  2: { desktop: Floor2Component, mobile: Floor2ComponentMobile },
  3: { desktop: Floor3Component, mobile: Floor3ComponentMobile },
  4: { desktop: Floor4Component, mobile: Floor4ComponentMobile },
  5: { desktop: Floor5Component, mobile: Floor5ComponentMobile },
  6: { desktop: Floor6Component, mobile: Floor6ComponentMobile },
  7: { desktop: Floor7Component, mobile: Floor7ComponentMobile },
  8: { desktop: Floor8Component, mobile: Floor8ComponentMobile },
  9: { desktop: Floor9Component, mobile: Floor9ComponentMobile },
  10: { desktop: Floor10Component, mobile: Floor10ComponentMobile },
  11: { desktop: Floor11Component, mobile: Floor11ComponentMobile },
  12: { desktop: Floor12Component, mobile: Floor12ComponentMobile },
  13: { desktop: Floor13Component, mobile: Floor13ComponentMobile },
  15: { desktop: Floor15Component, mobile: Floor15ComponentMobile },
  17: { desktop: Floor17Component, mobile: Floor17ComponentMobile },
  19: { desktop: Floor19Component, mobile: Floor19ComponentMobile },
  22: { desktop: Floor22Component, mobile: Floor22ComponentMobile },
  24: { desktop: Floor24Component, mobile: Floor24ComponentMobile },
  26: { desktop: Floor26Component, mobile: Floor26ComponentMobile },
  28: { desktop: Floor28Component, mobile: Floor28ComponentMobile },
  30: { desktop: Floor30Component, mobile: Floor30ComponentMobile },
  32: { desktop: Floor32Component, mobile: Floor32ComponentMobile },
  34: { desktop: Floor34Component, mobile: Floor34ComponentMobile },
  36: { desktop: Floor36Component, mobile: Floor36ComponentMobile },
  38: { desktop: Floor38Component, mobile: Floor38ComponentMobile },
};

const UnitSelectionBanner = ({ floor, data }) => {
  const currentFloor = parseInt(floor);
  const navigate = useNavigate(); // React Router hook for navigation
  const FloorComponent = isMobile ? floorComponents[currentFloor]?.mobile : floorComponents[currentFloor]?.desktop;

  const getFloorsInRange = (currentFloor) => {
    const currentIndex = floorList.indexOf(currentFloor);

    // Get the two previous and two next floors
    const previousFloors = floorList.slice(Math.max(currentIndex - 2, 0), currentIndex);
    const nextFloors = floorList.slice(currentIndex + 1, currentIndex + 3);

    return [...previousFloors, currentFloor, ...nextFloors];
  };

  const floors = getFloorsInRange(currentFloor);

  // Handle arrow click to move to previous or next floor
  const handleArrowClick = (direction) => {
    const currentIndex = floorList.indexOf(currentFloor);
    if (direction === 'prev' && currentIndex > 0) {
      navigate(`/unit-selection/${floorList[currentIndex - 1]}`);
      window.location.reload();
    } else if (direction === 'next' && currentIndex < floorList.length - 1) {
      navigate(`/unit-selection/${floorList[currentIndex + 1]}`);
      window.location.reload();
    }
  };

  // Handle clicking on a floor number to navigate directly to that floor
  const handleFloorClick = (floorNumber) => {
    navigate(`/unit-selection/${floorNumber}`);
    window.location.reload();
  };

  return (
    <div className='unit-selection-main-bg-clr'>
      <div className='container'>
        <div className='unit-selection-main-div'>
          {/* left-div */}
          {/* <div className='unit-selection-left-div'> */}
          <div className='border-right-div'></div>
          {/* top-div */}
          <div className='top-div'>
            {/* arrow-div */}
            <div className='arrow-div' onClick={() => navigate('/floor-selection')}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12" fill="none">
                <path d="M22.5 6.75C22.9142 6.75 23.25 6.41421 23.25 6C23.25 5.58579 22.9142 5.25 22.5 5.25L22.5 6.75ZM0.969669 5.46967C0.676777 5.76256 0.676777 6.23744 0.96967 6.53033L5.74265 11.3033C6.03554 11.5962 6.51041 11.5962 6.8033 11.3033C7.0962 11.0104 7.0962 10.5355 6.8033 10.2426L2.56066 6L6.8033 1.75736C7.09619 1.46447 7.09619 0.989593 6.8033 0.696699C6.5104 0.403806 6.03553 0.403806 5.74264 0.696699L0.969669 5.46967ZM22.5 5.25L1.5 5.25L1.5 6.75L22.5 6.75L22.5 5.25Z" fill="#D8C4AE" />
              </svg>
            </div>
            {/* text-div */}
            <div className='text-div'>
              <h6>Back to Visual Selection</h6>
            </div>
          </div>
          {/* middle-div */}
          <div className='middle-div-unit-selection'>
            {/* text-div */}
            <div className='text-div'>
              <h3>Floor</h3>
            </div>
            <div className='floor-text'>
              <h1>{currentFloor}</h1>
            </div>
          </div>

          {/* floor-text-buttons-div */}
          <div className='floor-text-buttons-div'>
            {/* floor-text */}

            {/* floor-button */}
            <div className='floor-button'>
              <div className='floor-button' onClick={() => handleArrowClick('prev')}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8" fill="none">
                  <path d="M15 4.5C15.2761 4.5 15.5 4.27614 15.5 4C15.5 3.72386 15.2761 3.5 15 3.5L15 4.5ZM0.646446 3.64645C0.451184 3.84171 0.451184 4.15829 0.646446 4.35356L3.82843 7.53554C4.02369 7.7308 4.34027 7.7308 4.53554 7.53554C4.7308 7.34027 4.7308 7.02369 4.53554 6.82843L1.70711 4L4.53553 1.17157C4.73079 0.976313 4.73079 0.65973 4.53553 0.464468C4.34027 0.269206 4.02369 0.269206 3.82842 0.464468L0.646446 3.64645ZM15 3.5L1 3.5L1 4.5L15 4.5L15 3.5Z" fill="#C8AA8E" />
                </svg>
              </div>
              <div className='number-div'>
                {/* {floors.map(floorNumber => (
                      <p key={floorNumber} onClick={() => handleFloorClick(floorNumber)} style={{ cursor: 'pointer' }}>
                        {floorNumber}
                      </p>
                    ))}
                     */}
                {floors.map(floorNumber => (
                  <p
                    key={floorNumber}
                    onClick={() => handleFloorClick(floorNumber)}
                    style={{
                      cursor: 'pointer',
                      color: floorNumber === currentFloor ? 'var(--Solid-green)' : 'var(--Light-gold)',
                    }}
                  >
                    {floorNumber}
                  </p>
                ))}
              </div>
              <div className='floor-button' onClick={() => handleArrowClick('next')}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8" fill="none">
                  <path d="M1.3335 3.5C1.05735 3.5 0.833496 3.72386 0.833496 4C0.833496 4.27614 1.05735 4.5 1.3335 4.5L1.3335 3.5ZM15.6871 4.35356C15.8823 4.15829 15.8823 3.84171 15.687 3.64645L12.5051 0.464468C12.3098 0.269206 11.9932 0.269206 11.798 0.464468C11.6027 0.65973 11.6027 0.976313 11.798 1.17158L14.6264 4L11.798 6.82843C11.6027 7.02369 11.6027 7.34027 11.798 7.53554C11.9932 7.7308 12.3098 7.7308 12.5051 7.53554L15.6871 4.35356ZM1.3335 4.5L15.3335 4.5L15.3335 3.5L1.3335 3.5L1.3335 4.5Z" fill="#C8AA8E" />
                </svg>
              </div>
            </div>
          </div>
          {/* bottom-div */}
          {/* <div className='bottom-div'> */}
            {/* text-div-bottom */}
            <div className='text-div-bottom'>
              <h3>Available Units: <span>{data.totalAvailable}</span></h3>
            </div>
            {/* unit-type-text */}
            <div className='unit-type-text'>
              <h4>Unit Types:</h4>
              {data.types.map(type => (
                <h6 key={type}>{type}</h6>
              ))}
            </div>
          {/* </div> */}
          {/* </div> */}

          {/* right-div */}
          <div className='right-div'>

            {FloorComponent ? <FloorComponent unitStatus={data.data} /> : <div>No floor layout available.</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitSelectionBanner;
